var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormularioBase',{attrs:{"tiposPermitidos":['ACESSO_DADOS_PESSOAIS', 'INCIDENTE_DADOS_PESSOAIS'],"sistema":"B2B","moduloKey":"ADMIN_FORMULARIOS","tabTitulo":"Formulários","context":"LGPD"}})
}
var staticRenderFns = []

export { render, staticRenderFns }